import React, { Component } from "react";
import {
  Form,
  FormGroup,
  FormControl,
  Button,
  Col,
  Row
} from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import _ from "lodash";

// utils
import { update } from "../../../utils/apiService";

// actions
import { updateVideo } from "../../../actions/index";

class UsersToExcludeForm extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleChange = this.handleChange.bind(this);

    this.state = {
      name: ""
    };

    this.submitForm = this.submitForm.bind(this);
    this.getNameValidationState = this.getNameValidationState.bind(this);
  }
  getNameValidationState() {
    const { users_to_exclude } = this.props.video;
    const name = this.state.name;
    const length = this.state.name.length;

    if (_.includes(users_to_exclude, name)) {
      return "error";
    }

    if (length > 0) return "success";

    return null;
  }
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }
  submitForm(e) {
    e.preventDefault();
    let nameValidationState = this.getNameValidationState();
    const { video, updateVideo } = this.props;

    if (nameValidationState === "error") {
      return;
    }

    if (this.state.name === "" || this.state.email === "") {
      this.setState({
        error: "Nome não pode ser vazio."
      });
      return;
    }

    this.setState({
      error: ""
    });

    let newUsersToExclude = [...video.users_to_exclude, this.state.name];

    let url = `/campaigns/${video.campaign_id}/videos/${video.id}`;
    let data = {
      video: {
        users_to_exclude: newUsersToExclude
      }
    };
    update(url, data)
      .then(res => {
        let updatedVideo = res.data;
        updateVideo(video.campaign_id, updatedVideo);
        toastr.success("User adicionado com sucesso!");
        this.setState({ name: "" });
      })
      .catch(err => {
        toastr.error("Ocorreu um erro. Tente novamente.");
      });
  }
  render() {
    return (
      <div className="users-form">
        <h2>Adicionar novo user_to_exclude</h2>
        <Form onSubmit={this.submitForm}>
          <Row>
            <Col md={5}>
              <FormGroup
                controlId="formBasicText"
                validationState={this.getNameValidationState()}
              >
                <FormControl
                  type="text"
                  name="name"
                  value={this.state.name}
                  placeholder="Digite o nome que será criado"
                  onChange={this.handleChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col md={2}>
              <Button type="submit">Adicionar</Button>
            </Col>
            <Col md={12}>
              <small className="text-danger">{this.state.error}</small>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateVideo: (campaignId, video) => {
      dispatch(updateVideo(campaignId, video));
    }
  };
};

export default connect(null, mapDispatchToProps)(UsersToExcludeForm);



// WEBPACK FOOTER //
// ./src/components/pages/UsersToExclude/UsersToExcludeForm.js